import React from 'react';
import { ClipboardCheckIcon, CalendarIcon, GraduationCapIcon, FileTextIcon } from 'lucide-react';
export function ServicesOverview() {
  return <section id="services" className="py-16 bg-white" data-id="element-397">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-398">
        <div className="text-center mb-16" data-id="element-399">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3A4A46] mb-4" data-id="element-400">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-401">
            Professional bookkeeping and tax services tailored to your business
            needs
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-402">
          {/* Setup & Training */}
          <a href="#setup-training" className="block" data-id="element-403">
            <div className="bg-gray-50 rounded-lg p-8 text-center hover:shadow-lg transition-shadow" data-id="element-404">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#8A9A5B] text-white mb-6" data-id="element-405">
                <GraduationCapIcon className="h-8 w-8" data-id="element-406" />
              </div>
              <h3 className="text-xl font-bold text-[#3A4A46] mb-4" data-id="element-407">
                Setup & Training
              </h3>
              <p className="text-gray-600" data-id="element-408">Feel in control from day one.</p>
            </div>
          </a>
          {/* Catch-up Bookkeeping */}
          <a href="#catchup-bookkeeping" className="block" data-id="element-409">
            <div className="bg-gray-50 rounded-lg p-8 text-center hover:shadow-lg transition-shadow" data-id="element-410">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#8A9A5B] text-white mb-6" data-id="element-411">
                <ClipboardCheckIcon className="h-8 w-8" data-id="element-412" />
              </div>
              <h3 className="text-xl font-bold text-[#3A4A46] mb-4" data-id="element-413">
                Catch-Up Bookkeeping
              </h3>
              <p className="text-gray-600" data-id="element-414">
                Get back on track with total peace of mind.
              </p>
            </div>
          </a>
          {/* Monthly Bookkeeping */}
          <a href="#monthly-bookkeeping" className="block" data-id="element-415">
            <div className="bg-gray-50 rounded-lg p-8 text-center hover:shadow-lg transition-shadow" data-id="element-416">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#8A9A5B] text-white mb-6" data-id="element-417">
                <CalendarIcon className="h-8 w-8" data-id="element-418" />
              </div>
              <h3 className="text-xl font-bold text-[#3A4A46] mb-4" data-id="element-419">
                Monthly Bookkeeping
              </h3>
              <p className="text-gray-600" data-id="element-420">
                Stay on top of your books- and your business.
              </p>
            </div>
          </a>
          {/* Tax Preparation */}
          <a href="#tax-preparation" className="block" data-id="element-421">
            <div className="bg-gray-50 rounded-lg p-8 text-center hover:shadow-lg transition-shadow" data-id="element-422">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#8A9A5B] text-white mb-6" data-id="element-423">
                <FileTextIcon className="h-8 w-8" data-id="element-424" />
              </div>
              <h3 className="text-xl font-bold text-[#3A4A46] mb-4" data-id="element-425">
                Tax Preparation
              </h3>
              <p className="text-gray-600" data-id="element-426">
                File with confidence- and keep more of what's yours.
              </p>
            </div>
          </a>
        </div>
      </div>
    </section>;
}